import React from 'react'
import { Button, NumberInput } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { AddToCartSectionRoot } from '../AddToCartSection'

export const ProductSkuSelectionLoading = () => (
  <AddToCartSectionRoot>
    <NumberInput value={1} min={1} max={999} />
    <Button size="large" disabled>
      <FormattedMessage id="add-to-cart" />
    </Button>
  </AddToCartSectionRoot>
)
